import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from '../../../../core/toast.service';
import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { SupplyFavorites } from '../../models/supply-favorites';
import { DeleteSupplyFavoritesService } from '../../services/delete-supply-favorites.service';

@Component({
  selector: 'app-single-favorite-product',
  templateUrl: './single-favorite-product.component.html',
  styleUrls: ['./single-favorite-product.component.scss']
})
export class SingleFavoriteProductComponent implements OnInit {

  @Input() singleFavorite: SupplyFavorites;
  rating: number;
  @Output() deleted: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(
    private deleteSupplyFavoritesService: DeleteSupplyFavoritesService,
    private toast: ToastService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    if(this.singleFavorite.supply_variant.supply_reviews_aggregate.aggregate.count){
      this.rating = (this.singleFavorite.supply_variant.supply_reviews_aggregate.aggregate.sum.rating /
      (this.singleFavorite.supply_variant.supply_reviews_aggregate.aggregate.count * 5)) * 5;
    } else {
      this.rating = 0;
    }
  }


  async deleteSupplyFavorites(ev: MouseEvent){
    ev.stopPropagation();
    this.spinner.show();
    try {
      await this.deleteSupplyFavoritesService.deleteSupplyFavorites(
        this.singleFavorite.supply_id,
        this.singleFavorite.supply_variant_id);
        this.spinner.hide();
      this.deleted.emit(true);

    } catch(error){
      this.spinner.hide();
       this.toast.openSnackBar('Unable to remove from favorites');
    }
  }

}
